/**
 * CoLab Mobile Menu Module
 * Бургер меню для мобільних пристроїв
 */

let burger = null;
let menu = null;
let overlay = null;

function init() {
    burger = document.querySelector('.header__burger');
    menu = document.querySelector('.mobile-menu');
    overlay = document.querySelector('.menu-overlay');

    if (!burger || !menu) return;

    bindEvents();
}

function bindEvents() {
    // Toggle menu
    burger.addEventListener('click', function() {
        toggle();
    });

    // Close on overlay click
    if (overlay) {
        overlay.addEventListener('click', function() {
            close();
        });
    }

    // Submenu toggles
    const submenuTriggers = document.querySelectorAll('.mobile-menu__link[data-submenu]');
    submenuTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            toggleSubmenu(this);
        });
    });

    // Close on escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen()) {
            close();
        }
    });
}

function toggle() {
    if (isOpen()) {
        close();
    } else {
        open();
    }
}

function open() {
    burger.classList.add('is-active');
    menu.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('menu-open');
}

function close() {
    burger.classList.remove('is-active');
    menu.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('menu-open');
}

function isOpen() {
    return menu.classList.contains('is-open');
}

function toggleSubmenu(trigger) {
    const submenuId = trigger.getAttribute('data-submenu');
    const submenu = document.getElementById(submenuId);

    if (submenu) {
        trigger.classList.toggle('is-open');
        submenu.classList.toggle('is-open');
    }
}

export const MobileMenu = {
    init
};
